import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { Button } from '../Button/Button.js';
import '../Button/ButtonBase/index.js';
import '../Button/ButtonBody/index.js';
import { Inline } from '../Inline/Inline.js';
import { useDisclosureContext } from './DisclosureProvider.js';

var DisclosureButton = forwardRef(function DisclosureButton(_a, ref) {
    var children = _a.children, _b = _a.look, look = _b === void 0 ? "link" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.tone, tone = _d === void 0 ? "primary" : _d, _e = _a.rounded, rounded = _e === void 0 ? false : _e, props = __rest(_a, ["children", "look", "size", "tone", "rounded"]);
    var context = useDisclosureContext({ optional: true });
    var toggleIsOpen = context.toggleIsOpen, id = context.id, isOpen = context.isOpen;
    return (jsx(Button, __assign({ ref: ref, onClick: toggleIsOpen, "aria-controls": id, "aria-expanded": isOpen, type: "button", look: look, size: size, tone: tone, rounded: rounded }, props, { children: jsx(Inline, __assign({ gap: "3" }, { children: children instanceof Function ? children(context) : children })) })));
});

export { DisclosureButton };
//# sourceMappingURL=DisclosureButton.js.map
